/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAuthToken } from '@/utils/auth.utils'
import HttpRequest from './http-request'

class StockMappingProvider extends HttpRequest {
  getLocationByName (name: string): Promise<any> {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/master/by-name', { name })
  }

  mappingLocation (payload: any): Promise<any> {
    this.setHeader(getAuthToken())
    return this.create('/stock-mapping/mapping', payload)
  }

  moveLocation (payload: any): Promise<any> {
    this.setHeader(getAuthToken())
    return this.patch('/stock-mapping/mapping/move-location', payload)
  }

  getMappingByLocation (query: any): Promise<any> {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/mapping/by-location', query)
  }

  getSumQtyByLocation (location: string): Promise<any> {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/mapping/sum-qty', { location })
  }

  getMappingAllStores (query: any): Promise<any> {
    this.setHeader(getAuthToken())
    return this.get('/stock-mapping/mapping/all-stores', query)
  }
}

export default StockMappingProvider
